<template>
  <div>
    <heading><small>Reset password</small></heading>
    <form-message v-if="message"
                  :severity="msgSeverity"
                  :message="message"/>
    <request-form v-if="step === 'email'"
                  :email="email"
                  @submit="requestEmail">
    </request-form>
    <code-form v-if="step === 'code'"
               @submit="storeCode">
    </code-form>
    <password-form v-if="step === 'password'"
                   @submit="changePassword">
    </password-form>
    <form-button v-if="step === 'done'"
                 :focus="true"
                 color="blue"
                 pull="right"
                 @click="$router.go(-1)">
      Sign in
    </form-button>
    <form-button v-else
                 pull="left"
                 @click="$router.go(-1)">
      Cancel
    </form-button>
  </div>
</template>

<script>
import { requestReset, completeReset, logout } from '../auth';

import Heading from './elements/Heading';
import FormButton from './elements/FormButton';
import FormMessage from './elements/FormMessage';

import RequestForm from './forms/RequestPasswordReset';
import PasswordForm from './forms/Password';
import CodeForm from './forms/VerificationCode';

export default {
  components: {
    Heading,
    FormButton,
    FormMessage,
    RequestForm,
    CodeForm,
    PasswordForm,
  },

  data() {
    return {
      message: '',
      error: false,
      step: 'email',
      username: null,
      code: null,
    };
  },

  props: {
    email: { type: String },
  },

  computed: {
    msgSeverity: function isError() {
      return this.error ? 'warning' : 'information';
    },
  },

  methods: {
    requestEmail: function requestEmail({ email }) {
      const self = this;
      this.username = email;

      requestReset({
        username: this.username,
        success: () => {
          self.message = `Verification code sent to ${email}, ` +
            'check your inbox and spam folder.';
          self.error = false;
          self.step = 'code';
        },
        error: (err) => {
          self.error = true;
          self.message = err;
        },
      });
    },

    storeCode: function storeCode({ code }) {
      this.code = code;
      this.step = 'password';
      this.message = '';
      this.error = false;
    },

    changePassword: function changePassword({ password }) {
      const self = this;

      completeReset({
        password,
        username: this.username,
        code: this.code,
        success: () => {
          logout();

          self.step = 'done';
          self.message = 'Password changed. Sign in with your new password ' +
                         'to verify that you typed it correctly. ' +
                         'If not you can reset again.';
          self.error = false;
        },
        error: (err) => {
          // check which step to revert to?
          self.step = 'code';
          self.message = err;
          self.error = true;
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PasswordReset.vue